export default __webpack_public_path__ + "static/media/OAuthDiagram (002).17cf8e77.png";